import { render, staticRenderFns } from "./BasicLogo.vue?vue&type=template&id=4d227620"
import script from "./BasicLogo.vue?vue&type=script&lang=js"
export * from "./BasicLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports